import { ReactNode } from "react";
import { Info } from "lucide-react";
import { cn } from "~/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";

// Info (ⓘ) icon that reveals a longer explanation on hover/focus. Replaces the
// the legacy WFP-UI FormHint (which was a Tooltip wrapping an info glyph).
interface Props {
  children?: ReactNode;
  className?: string;
}

const FormHint = ({ children, className }: Props) => {
  if (!children) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          className={cn("inline-flex shrink-0 cursor-help", className)}
        >
          <Info className="size-4 fill-primary-600 text-white" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="z-[10000] max-w-xs whitespace-normal">{children}</TooltipContent>
    </Tooltip>
  );
};

export default FormHint;
